export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 9_04.a02b343a.jpg";